import { getStaticAsset } from "core/model/config";
import { useTranslations } from "translations";
import { InfoScreen } from "./index";

export function FormSubmittedSuccess() {
  const translations = useTranslations();

  return (
    <InfoScreen
      image={getStaticAsset("admissions-mail-sent.svg")}
      imageAlt={
        translations.careproviderApp.recareAdmissionsForm
          .emailSubmittedSuccessfully.altTextImage
      }
      pageTitle={
        translations.careproviderApp.recareAdmissionsForm.pageTitles
          .pageFormSubmittedSuccessfully
      }
      paragraphOne={
        translations.careproviderApp.recareAdmissionsForm
          .formSubmittedSuccessfully.paragraphOne
      }
      paragraphTwo={
        translations.careproviderApp.recareAdmissionsForm
          .formSubmittedSuccessfully.paragraphTwo
      }
      title={
        translations.careproviderApp.recareAdmissionsForm
          .formSubmittedSuccessfully.title
      }
    />
  );
}
